module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAo0lEQVQoU42S0RGCMBBEH5WgnWglDpWIlYiVoJVoJzrPyTnnQID9yUfysnubNGzTCByADhiaDUxfzpzL2q1B3q7LJYGvJehZ4uyAawLbGiRwK7e3wCOB/RyUAedw+NAdmMSbA4wn/DPITkvAXoewC8iGzK0iUjj8AR4QclMXN23JAqpAQPF4eT0BxxwpfwKdjBZ5fUyla1VCb8AqjfWtdO1rfQC5YSjsYGb7NAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bpen.png
// module id = h6nS
// module chunks = 2